export default {
    activity1011Config: {
        title: '1011任务配置',
        saveSection: '保存配置',
        reload: '重新加载',
        pageDesc:
            '读写 configs key=activity：活动时间、任务、签到积分、传播加分与排行榜奖励，各分区独立保存。',
        configExists: '已存在，将更新',
        configNew: '尚未创建，保存时新建',
        sections: {
            basic: '基础信息',
            time: '活动时间配置',
            tasks: '任务管理',
            checkin: '签到积分配置',
            spread: '传播加分标准',
            rewards: '排行榜奖励配置',
        },
        fields: {
            title: '活动标题',
            status: '状态',
            activityId: '活动 ID',
            timeRange: '活动起止时间',
            points: '积分',
            threshold: '阈值',
            checkinDay: '第 {day} 天',
            typePlaceholder: '选择任务类型',
            ruleTitle: '规则 {index}：每 {threshold} 次{metric}',
            ruleEvery: '每',
            ruleTimes: '次',
            rulePoints: '分',
        },
        status: {
            enabled: '启用',
            disabled: '停用',
        },
        platforms: {
            x: 'X (Twitter)',
            tiktok: 'TikTok',
            youtube: 'YouTube',
            other: '其他平台',
        },
        metrics: {
            play: '播放',
            like: '点赞',
            retweet: '转推',
        },
        columns: {
            taskId: 'ID',
            type: '类型',
            description: '任务名称',
            points: '积分',
            linkUrl: '链接',
            minRank: '最低排名',
            maxRank: '最高排名',
            amount: '奖励金额',
            action: '操作',
        },
        actions: {
            addTask: '新增任务',
            addTier: '新增档位',
        },
        empty: {
            tasks: '暂无任务，请新增',
            rewards: '暂无奖励档位，请新增',
        },
        load: {
            failed: '加载配置失败',
        },
        save: {
            success: '配置已保存',
            failed: '保存失败',
            conflict: '配置已被他人更新，已重新加载，请确认后再保存',
        },
    },
};
